/* Kite homepage: show the floating bottom bar after the hero, hide it again once the final CTA
   (which has the same buttons) comes into view. */
(function () {
  var bar = document.querySelector('[data-kh-fnav]');
  if (!bar) return;
  var hero = document.querySelector('.hero-section');
  var cta = document.querySelector('.kh-cta');
  var ticking = false;

  function update() {
    ticking = false;
    var threshold = hero ? hero.offsetTop + hero.offsetHeight * 0.6 : 400;
    var atCta = cta ? cta.getBoundingClientRect().top < window.innerHeight - 40 : false;
    bar.classList.toggle('is-shown', window.scrollY > threshold && !atCta);
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    },
    { passive: true }
  );
  update();
})();

/* Feature grid: scale each 380×300 illustration to its tile's width. */
(function () {
  var media = document.querySelectorAll('.kfg-media');
  if (!media.length) return;
  function fit(el) {
    if (el.clientWidth) el.style.setProperty('--k', el.clientWidth / 380);
  }
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        fit(entry.target);
      });
    });
    media.forEach(function (el) {
      ro.observe(el);
    });
  }
  media.forEach(fit);
})();

/* Widgets section: scale artboards to their tiles, live corner/colour controls, countdown. */
(function () {
  var root = document.querySelector('.kws');
  if (!root) return;

  var medias = root.querySelectorAll('.kws-wt-media');
  function fit(m) {
    var art = m.querySelector('.kws-art');
    if (!art || !art.offsetWidth) return;
    m.style.setProperty('--k', m.clientWidth / art.offsetWidth);
    m.style.setProperty('--k2', m.clientHeight / art.offsetHeight);
  }
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        fit(entry.target);
      });
    });
    medias.forEach(function (m) {
      ro.observe(m);
    });
  }
  medias.forEach(fit);

  var arts = root.querySelectorAll('#kws-kwsGrid .kws-art');
  function group(selector, attr, prop) {
    var buttons = root.querySelectorAll(selector);
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        buttons.forEach(function (x) {
          x.setAttribute('aria-pressed', x === b);
        });
        arts.forEach(function (a) {
          a.style.setProperty(prop, b.getAttribute(attr));
        });
      });
    });
  }
  group('#kws-segR button', 'data-r', '--wr');
  group('.kws-sw', 'data-c', '--acc');

  var h = root.querySelector('#kws-cdH'), mEl = root.querySelector('#kws-cdM'), s = root.querySelector('#kws-cdS');
  if (!h || !mEl || !s) return;
  var secs = 2 * 3600 + 14 * 60 + 9;
  function pad(n) {
    return String(n).padStart(2, '0');
  }
  setInterval(function () {
    secs = secs > 0 ? secs - 1 : 8000;
    h.textContent = pad(Math.floor(secs / 3600));
    mEl.textContent = pad(Math.floor((secs % 3600) / 60));
    s.textContent = pad(secs % 60);
  }, 1000);
})();

/* Carousels: tell the shared controls how many dots there are (--kh-n), so prev/next sit beside them.
   With a single page (everything visible) the controls are hidden. */
(function () {
  var sliders = document.querySelectorAll('.brand-demo-slider.w-slider, .review-slider.w-slider');
  if (!sliders.length) return;
  function count() {
    sliders.forEach(function (slider) {
      var nav = slider.querySelector('.w-slider-nav');
      var n = nav ? nav.children.length : 0; // one dot per page, drawn by webflow.js
      slider.style.setProperty('--kh-n', n || 1);
      slider.classList.toggle('kh-one-page', n <= 1);
    });
  }
  window.addEventListener('load', function () {
    count();
    setTimeout(count, 600);
  });
  window.addEventListener('resize', function () {
    setTimeout(count, 300);
  });
})();

/* Fixed artboards (bulk codes): scale to their box. */
(function () {
  var boxes = document.querySelectorAll('.kh-artbox');
  if (!boxes.length) return;
  function fit(box) {
    var art = box.querySelector('.kh-artboard');
    if (art && art.offsetWidth && box.clientWidth) box.style.setProperty('--k', box.clientWidth / art.offsetWidth);
  }
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        fit(entry.target);
      });
    });
    boxes.forEach(function (b) {
      ro.observe(b);
    });
  }
  boxes.forEach(fit);
})();
